module.exports = __webpack_public_path__ + "open-sans-latin-600.98983d27f1a1a9dbad0e.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-600.woff2
// module id = ../../../../typeface-open-sans/files/open-sans-latin-600.woff2
// module chunks = 1 3